import {
  GET_APP_TRACK_LIST_FAIL,
  GET_APP_TRACK_LIST_REQUEST,
  GET_APP_TRACK_LIST_SUCCESS,
  GET_APP_TRACK_BY_DATE_LIST_FAIL,
  GET_APP_TRACK_BY_DATE_LIST_REQUEST,
  GET_APP_TRACK_BY_DATE_LIST_SUCCESS,
} from "../../types/user/appTrackTypes";

export const getUserAppTrackReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_APP_TRACK_LIST_REQUEST:
      return {
        ...state,
        appLoading: true,
      };
    case GET_APP_TRACK_LIST_SUCCESS:
      return {
        ...state,
        appLoading: false,
        appInfo: payload,
        appError: "",
      };
    case GET_APP_TRACK_LIST_FAIL:
      return {
        ...state,
        appLoading: false,
        appError: payload,
        appInfo: {},
      };
    default:
      return state;
  }
};

export const getUserAppTrackByDateReducers = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_APP_TRACK_BY_DATE_LIST_REQUEST:
        return {
          ...state,
          appLoading: true,
        };
      case GET_APP_TRACK_BY_DATE_LIST_SUCCESS:
        return {
          ...state,
          appLoading: false,
          appInfo: payload,
          appError: "",
        };
      case GET_APP_TRACK_BY_DATE_LIST_FAIL:
        return {
          ...state,
          appLoading: false,
          appError: payload,
          appInfo: {},
        };
      default:
        return state;
    }
  };